/** Permissive fallback for patterns we can't model. */
export const ALPHANUMERIC_MASK = /^[a-zA-Z0-9]*$/;

/** AT&T order number, for SKUs on the AT&T branch that carry no pattern. */
export const ATT_ORDER_NUMBER_MASK = "00-000000000000000";

// Separators that mean themselves in the source pattern. `.` is excluded on purpose: it
// means "any character" there but a literal dot in a mask, so translating it narrows input.
const TRANSLATABLE = /^(?:\\d\{\d+\}|[-\s/])+$/;
const TOKEN = /\\d\{(\d+)\}|([-\s/])/g;

/**
 * IMask pattern for a `confirmationCodePattern` built from `\d{n}` runs and literal
 * separators, e.g. `^\d{2}-\d{15}$` → `00-000000000000000`. The fallback mask permits only
 * `[a-zA-Z0-9]`, so without this a pattern needing a separator can't be typed at all.
 *
 * `undefined` for anything else, so unrecognised patterns keep the fallback.
 */
export function confirmationCodeMask(pattern: string | undefined): string | undefined {
    if (!pattern) return undefined;

    const body = pattern.replace(/^\^/, "").replace(/\$$/, "");
    if (!body || !TRANSLATABLE.test(body)) return undefined;

    let mask = "";
    for (const [, digitCount, separator] of body.matchAll(TOKEN)) {
        mask += digitCount ? "0".repeat(Number(digitCount)) : separator;
    }
    return mask;
}
